<template>
  <div class="common-propblem">
    <div class="content-box">
      <div class="item" v-for="(item, index) in problemData" :key="index">
        <div class="item-title" @click="changeCur(index)">
          <div class="left">
            <img class="question" :src="styleData.iconQuestion" alt="" />
            {{ item.title }}
          </div>
          <div
            class="icon"
            :class="{ 'img-rotate': cur == index && showAnswer }"
          >
            <img src="../../assets/common/icon-down.png" alt />
          </div>
        </div>

        <div class="answer-box">
          <div
            class="item-answer"
            v-for="(item1, index1) in item.answer"
            :key="index1"
            :class="{ 'show-answer': cur == index && showAnswer }"
          >
            {{ item1 }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["problemData", "styleData"],
  data() {
    return {
      cur: -1,
      showAnswer: true,
    };
  },
  methods: {
    changeCur(index) {
      if (index == this.cur) {
        this.showAnswer = !this.showAnswer;
      } else {
        this.showAnswer = true;
        this.cur = index;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.common-propblem {
  .content-box {
    margin: 0 auto;
    margin-top: 48px;
    padding: 16px 48px 16px 32px;
    width: 686px;
    background: #ffffff;
    box-shadow: 0px 6px 18px 0px rgba(94, 123, 218, 0.08),
      0px 4px 6px -4px rgba(94, 123, 218, 0.12);
    border-radius: 16px;
    box-sizing: border-box;

    .item {
      border-bottom: 1px solid #e6ebed;

      &:last-child {
        border-bottom: none;
      }
      .item-title {
        position: relative;
        display: flex;
        justify-content: space-between;
        padding: 34px 0px 32px 0px;
        z-index: 5;
        .left {
          display: flex;
          font-size: 28px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #1d2129;
          line-height: 44px;
          .question {
            margin-top: 5px;
            margin-right: 12px;
            max-width: 32px;
            min-width: 32px;
            height: 32px;
            object-fit: cover;
          }
        }
        .icon {
          margin-left: 26px;
          max-width: 32px;
          min-width: 32px;
          height: 32px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }

      .item-answer {
        position: relative;
        padding-left: 44px;
        font-size: 26px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #4e5969;
        line-height: 40px;
        max-height: 0;
        opacity: 0;
        transition: 0.3s ease all;
        overflow: hidden;
        z-index: 3;
      }

      .show-answer {
        // padding: 0px 24px;
        margin-top: 16px;
        // display: block;
        max-height: 800px;
        opacity: 1;
        line-height: 44px;
        transition: 0.4s ease all;
      }
      .show-answer:nth-child(1) {
        margin-top: 0px;
      }
      .show-answer:last-child {
        padding-bottom: 32px;
      }
    }

    .img-rotate {
      transition: 0.5s ease all;
      transform: rotate(180deg);
    }
  }
}
</style>
